// extracted by mini-css-extract-plugin
export var background = "Footer-module--background--9e101";
export var cookiePreferences = "Footer-module--cookiePreferences--083cc";
export var footerIcon = "Footer-module--footerIcon--5148e";
export var footerLogo = "Footer-module--footerLogo--93b2d";
export var footer__logo = "Footer-module--footer__logo--1d930";
export var footer__logoText = "Footer-module--footer__logoText--65c40";
export var footer__logo__textLowOpacity = "Footer-module--footer__logo__textLowOpacity--a2343";